import { render, staticRenderFns } from "./EntitySpan.vue?vue&type=template&id=11e76358&lang=pug&"
import script from "./EntitySpan.vue?vue&type=script&lang=ts&"
export * from "./EntitySpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports